import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import es_ES from 'antd/locale/es_ES';
import './Config/dayjsConfig';
import App from './App';
import 'antd/dist/reset.css';
import { AuthProvider } from './Components/Context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <ConfigProvider locale={es_ES}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ConfigProvider>
  //</React.StrictMode>
);